import { gql } from "@apollo/client";

const activechatcountchanged = gql`
  subscription activechatcountchanged {
    activechatcountchanged {
      success
      error
      result
    }
  }
`;
export default activechatcountchanged;
